import { Card, Paper } from '@mui/material';

interface BakeasyPaperProps {
  children: any;
}
function BakeasyPaper(props: BakeasyPaperProps) {
  return (
    <Paper component={Card} variant="outlined" sx={{ p: 1.5 }}>
      {props?.children}
    </Paper>
  );
}

export default BakeasyPaper;
